import { render, staticRenderFns } from "./ResultButton.vue?vue&type=template&id=4ac316e4&"
import script from "./ResultButton.vue?vue&type=script&lang=js&"
export * from "./ResultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports